module.exports = __webpack_public_path__ + "477979f695d1110ff4665ec787bd418b.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/ss-glyphish-filled.eot
// module id = 56
// module chunks = 0